
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/giveback",
      function () {
        return require("private-next-pages/fr/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/giveback"])
      });
    }
  